import { useCallback, useRef, useEffect, useState } from 'react'
import type { Block, Variable, DemoBackground, DemoTheme } from './types'
import { updateDemo } from './api'

export function useAutoSave(demoId: string) {
  const [saving, setSaving] = useState(false)
  const saveTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const scheduleAutoSave = useCallback(
    (newBlocks: Block[], newVariables: Variable[], newBackground?: DemoBackground, newTheme?: DemoTheme) => {
      if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current)
      saveTimeoutRef.current = setTimeout(async () => {
        setSaving(true)
        try {
          await updateDemo(demoId, {
            content: {
              variables: newVariables,
              blocks: newBlocks,
              background: newBackground,
              theme: newTheme,
            },
          })
        } catch (e) {
          console.error('Auto-save failed:', e)
        } finally {
          setSaving(false)
        }
      }, 1000)
    },
    [demoId]
  )

  useEffect(() => {
    return () => {
      if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current)
    }
  }, [])

  return { saving, scheduleAutoSave }
}
